import qs from "qs";
import { routes } from "@twiliointernal/e2-commons-shared-definitions";

export const handleTicketSubmissionRedirect = ({
  chatId,
  handleRedirectAction,
  sessionId,
  additionalQueryParams = "",
}: {
  chatId: string;
  handleRedirectAction: (url: string) => void;
  sessionId?: string;
  additionalQueryParams?: string;
}): void => {
  const queryParams = qs.stringify(
    {
      chatId,
      sessionId,
    },
    {
      addQueryPrefix: true,
    }
  );

  const submitPath = `${routes.ticketSubmission.slice(
    1
  )}${queryParams}${additionalQueryParams}`;

  handleRedirectAction(submitPath);
};
